<template>
   <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
            <!--SLIDE-1-->
				<div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Actividad de autoevaluación">
					<div class="container-fluid">
						<div class="row" id="slide-1">
							<div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 pr-0 p-2 ">
								<div class="p-3 pl-lg-5">
									<h2 class="mt-5">Actividad de autoevaluación</h2>
									<h3>Análisis textual </h3>
									<h5>Tipo de actividad: cuestionario</h5>
									<h4 class="mt-3 pt-xl-5 pt-lg-5 pt-3">Objetivo</h4>
									<p>Caracterizar los componentes específicos del desarrollo cognitivo.</p>
									<h4 class="mt-3">¿Qué hacer?</h4>
                                    <p>Lea con atención los enunciados y seleccione la respuesta que considere correcta.</p>
                                </div>
							</div>
							<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 Fondo-AE justify-content-center align-items-center"> 
                               <p class="RefimgActiv">Foto de Gustavo Fring en <a class="text-white" href="https://www.pexels.com/es-es/foto/mujer-lapiz-mono-colegio-4173106/" target="_blank">Pexels</a></p>
                                <div class="w-100 pl-lg-3 pr-lg-3 pl-1 pr-1 pt-5 mt-lg-5 mb-5 pb-5">
									<div class="row ml-xl-3 bg-white ml-lg-1 ml-0 mr-xl-3 mr-lg-1 mr-0 vh-xl-100 p-4">
                                        <div class="col-12 mb-4">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>1. El concepto de estadio, según la teoría de Piaget, se define como:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html="respuesta1Neg"  class="Radiobutton checkAE mr-2 checkAE_1 " id="checkAE_1_A" @click="activar($event,1)"></button>
                                                   </div>
                                                   <p>a) El espacio evolutivo en el cual los niños y niñas llevan a cabo su desarrollo cognitivo. </p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta1Pos' class="Radiobutton checkAE mr-2 checkAE_1" id="checkAE_1_B" @click="activar($event,1)"></button>
                                                   </div>
                                                   <p>b) Un período evolutivo, que determina los cambios en el desarrollo que se van realizando en los niños y niñas. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>2. Una característica del estadio preoperacional es:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                      <button v-b-popover.click.blur.html='respuesta2Neg' class="Radiobutton checkAE mr-2 checkAE_2" id="checkAE_2_A" @click="activar($event,2)"></button>
                                                   </div>
                                                   <p>a) El niño desarrolla procesos de seriación y clasificación del manejo del razonamiento hipotético-deductivos. </p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                      <button v-b-popover.click.blur.html="respuesta2Pos" class="Radiobutton checkAE mr-2 checkAE_2" id="checkAE_2_B" @click="activar($event,2)"></button>
                                                   </div>
                                                   <p>b) Es el paso de la acción a la inteligencia, cuando comienza el mundo simbólico como proceso de desarrollo en los niños y niñas. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>3. Sobre el período de desarrollo, donde los niños alcanzan la capacidad simbólica y, por ende, del lenguaje, ¿cuál es la diferencia en este estadio que presentan las teorías de Piaget y Vygotsky?</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html="respuesta3Pos" class="Radiobutton checkAE mr-2 checkAE_3" id="checkAE_3_A" @click="activar($event,3)"></button>
                                                   </div>
                                                   <p>a) Se diferencian en el lugar que le dan al desarrollo de los procesos de socialización y egocentrismo en el niño. </p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta3Neg' class="Radiobutton checkAE mr-2 checkAE_3" id="checkAE_3_B" @click="activar($event,3)"></button>
                                                   </div>
                                                   <p>b) Se diferencian en el lugar que le dan al desarrollo de la capacidad simbólica en el niño.</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>4. Se asume que el juego tiene un valor fundamental para una de estas teorías del desarrollo, por cuanto cumple la función socializadora. Por lo tanto, la teoría que explica este es:</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                        <button v-b-popover.click.blur.html="respuesta4Pos" class="Radiobutton checkAE mr-2 checkAE_4" id="checkAE_4_A" @click="activar($event,4)"></button>
                                                   </div>
                                                   <p>a) La teoría sociocultural de Vygotsky.</p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta4Neg' class="Radiobutton checkAE mr-2 checkAE_4" id="checkAE_4_B" @click="activar($event,4)"></button>
                                                   </div>
                                                   <p>b) La teoría cognitiva de Piaget.</p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                           <div class="row">
                                               <div class="col-12 mb-3">
                                                   <b>5. La importancia de las teorías del desarrollo para la lingüística radica en la necesidad de…</b>
                                               </div>
                                               <div class="col-12 d-flex">
                                                   <div>
                                                       <button v-b-popover.click.blur.html='respuesta5Pos' class="Radiobutton checkAE mr-2 checkAE_5" id="checkAE_5_A" @click="activar($event,5)"></button>
                                                   </div>
                                                   <p>a) Comprender los fenómenos de adaptación y las dificultades inherentes al lenguaje. </p>
                                               </div>
                                                <div class="col-12 d-flex">
                                                   <div>
                                                      <button v-b-popover.click.blur.html="respuesta5Neg" class="Radiobutton checkAE mr-2 checkAE_5" id="checkAE_5_B" @click="activar($event,5)"></button>
                                                   </div>
                                                   <p>b) Interpretar los sistemas lingüísticos que se producen en el desarrollo. </p>
                                               </div>
                                           </div>
                                        </div>

                                        <div class="col-12">
                                            <button class="btn BtnPrincipal d-flex mx-auto mt-4 mb-4" @click="recargarPagina">Intentar nuevamente</button>
                                        </div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
        </div>
    </div>
</template>

<script>
import {SwiperController} from '../assets/RecursosITM/js/Swiper'

export default {
    name: 'AutoEvaluacion',
    data(){
      return{
        respuesta1Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Son aquellos que marcan un paso a paso en cada etapa del desarrollo que se sustenta en criterios como los períodos de ciclos en los cuales un estadio transcurre tras el otro.</p>',
        respuesta1Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',

        respuesta2Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Se entiende este estadio como aquel que implica todo el sistema de representaciones y origina el conocimiento en el niño. De aquí deriva la explicación sobre el lenguaje, la creación del signo y la representación que se tiene sobre la realidad.</p>',
        respuesta2Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',

        respuesta3Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">A diferencia de Piaget, que consideraba el egocentrismo como el escenario ideal para la resolución de la capacidad simbólica en los niños, el modelo propuesto por Vygotsky se basa en la dualidad exterioridad/interioridad, que lleva a una doble función verbal: la de comunicar y pensar.</p>',
        respuesta3Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',

        respuesta4Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Es en el marco del juego, el niño puede desplegar su imaginación más allá de lo real, por lo que crea mundos de fantasía y creatividad que le permiten la construcción de ámbitos simbólicos que facilitan el lenguaje.</p>',
        respuesta4Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',

        respuesta5Pos: '<p class="text-center" style="color: #671082 !important;"><b>¡Muy bien!</b></p> <p style="color: #333333 !important">Las teorías del desarrollo ilustran y permiten la comprensión sobre los mecanismos del lenguaje en el ser humano. </p>',
        respuesta5Neg: '<p class="text-center" style="color: #671082 !important;"><b>¡Incorrecto!</b></p> <p style="color: #333333 !important">Analice nuevamente los enunciados e intente una vez más.</p>',

        popovers:[false,false,false,false,false]
      }
    },
    methods: {
    activar: function(event,numPregunta){
   
      let elementosGrupo=document.querySelectorAll(".checkAE_"+numPregunta);
     
      elementosGrupo.forEach(element => {
          element.classList.remove("active","i-check");
      });

     event.target.classList.add("active","i-check");

    
    //    elementosGrupo.forEach(element => {
    //     element.style.pointerEvents='none';
    //    });

    },

    recargarPagina: function(){
        location.reload();
    }
  },
    mounted(){
        SwiperController(),
        document.title = this.$route.meta.title // Cambiar el título de la página
    }
}
</script>